// extracted by mini-css-extract-plugin
module.exports = {"Tempsdiv":"tempsDetail_Tempsdiv__ek-JH","Temps":"tempsDetail_Temps__2LOca","temp":"tempsDetail_temp__1PiTg","button":"tempsDetail_button__3qWaO"};